"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScopedBusinessEntity = void 0;
class ScopedBusinessEntity {
    STORAGE_KEY = 'business-entity-id';
    storage = sessionStorage;
    getId() {
        const id = this.storage.getItem(this.STORAGE_KEY);
        if (!this.validateId(id))
            return null;
        return id;
    }
    setId(id) {
        if (this.validateId(id)) {
            this.storage.setItem(this.STORAGE_KEY, id);
            return id;
        }
        console.error(`Error setting scoped business entity. Invalid business entity id: ${id}`);
        return null;
    }
    clearId() {
        this.storage.removeItem(this.STORAGE_KEY);
    }
    getStorageKey() {
        return this.STORAGE_KEY;
    }
    validateId(value) {
        if (!value)
            return false;
        return this.isNumericString(value);
    }
    isNumericString(value) {
        return /^[0-9]+$/.test(value);
    }
}
exports.ScopedBusinessEntity = ScopedBusinessEntity;
//# sourceMappingURL=ScopedBusinessEntity.js.map